import AccessTokens from './AccessTokens'

export default AccessTokens
